export default "__VITE_ASSET__BwoFFLMX__"